import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {


  private _subs: Subscription[] = [];
  public termsAndConditions = '';
  public useRebrandedLayout: boolean;

  constructor(
    public helperService: HelperService,
    private _activatedRoute: ActivatedRoute,
    private config: ConfigService,
    private featureFlagService: FeatureFlagsService,
    private _viewportScroller: ViewportScroller) {

    this.termsAndConditions = this.config.get('termsAndConditions');
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  ngOnInit(): void {
    this._subs.push(
      this._activatedRoute.queryParams
        .subscribe(params => {
          if (params && params.scrollToSection) {
            this._viewportScroller.scrollToAnchor(params.scrollToSection);
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
      this._subs.forEach(s => s.unsubscribe());
  }

}
